import { makeAction } from 'util/reduxhelper'


/* SET BRAND ******************************************************************/

export const SET_LOGO = 'brand/SET_LOGO'
export const setLogo = (logo) => {
  return makeAction(SET_LOGO, { logo })
}



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/brand.js